var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "../shared/utils";
function handleChosenRevealEvent(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var revealData = normalizeObject(__assign({ event: "notification_view", event_action: "chosen_reveal_view", event_category: "chosen_reveal", non_interaction: 1, notification_action: "notification_view", notification_location: "chosen_reveal" }, eventData));
    dataLayerPush(revealData);
}
export { handleChosenRevealEvent };
